export enum ChipSize {
    heavy = 'heavy',
    medium = 'medium',
    light = 'light',
}
